// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer__topBanner":"BannersWeb_bannerContainer__topBanner__bLBKW","bannerContainer__topBanner--mobile":"BannersWeb_bannerContainer__topBanner--mobile__PXjRZ"};